import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { locusClearState } from 'reducers/locus/reducer'
import LocusList from './LocusList'
import LocusItem from './LocusItem'

function Locus(props) {
  const {
    match: {
      params: { id },
    },
    locusClearState,
  } = props
  const LocusContent = id ? LocusItem : LocusList

  useEffect(
    () => () => {
      locusClearState()
    },
    [],
  )

  return (
    <div className="content">
      <LocusContent {...props} />
    </div>
  )
}

Locus.propTypes = {
  locusClearState: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
}

export default connect(null, {
  locusClearState,
})(Locus)
